module.exports = __webpack_public_path__ + "static/media/tile-price-1.1980c2ad.jpg";